<div class="alerts-container">
  @for (alert of headerAlerts$ | async; track alert) {
    <mat-toolbar class="header-alert {{ alert.theme }}">
      <div class="content-container">
        <div class="text">
          @if (alert.iconName) {
            <emperor-icon
              [name]="alert.iconName"
              [title]="alert.iconName"
              class="resize-icon"
            ></emperor-icon>
          }
          <span [innerHTML]="alert.message"></span>
        </div>
        <div class="buttons">
          @for (button of alert.buttons; track button) {
            <button
              matButton
              [attr.role]="button.role"
              (click)="alertButtonClick(alert, button)"
            >
              {{ button.text }}
            </button>
          }
        </div>
      </div>
    </mat-toolbar>
  }
</div>
